/**
 * Route definitions for the RaptorJob module.
 * Lazily loads page components for job list, job creation, job overview, job tickets, and deployments.
 */
import createFeatureRoutes from '@/common/presentation/components/MainRouteHelper/MainRouteHelper';
import { DEFAULT_PARAMS } from '../application/hooks/useRaptorJobQuery';

const RaptorJobRoutes = createFeatureRoutes(
  'raptorjob',
  {
    list: () => import('../presentation/pages/ListPage'),
    overview: () => import('../presentation/pages/OverviewPage'),
    new: () => import('../presentation/pages/CreatePage'),
    tickets: () => import('../presentation/pages/TicketsPage'),
    deployments: () => import('../presentation/pages/DeploymentsPage'),
    ticketOverviewDetails: () => import('../presentation/pages/JobTicketOverviewDetailsPage')
  },
  [
    { path: '', pageKey: 'list' },
    { path: 'new', pageKey: 'new' },
    { path: ':id', pageKey: 'overview' },
    { path: 'job-tickets/:ticketId', pageKey: 'tickets' },
    { path: ':id/deployments', pageKey: 'deployments' },
    { path: ':jobId/job-tickets/:ticketId/details', pageKey: 'ticketOverviewDetails' }
  ]
);

export const raptorJobRoutesMap = {
  list: `/raptorjob?module=${DEFAULT_PARAMS.module}&submodule=dispatch`,
  create: `/raptorjob/new?module=${DEFAULT_PARAMS.module}&submodule=dispatch`,
  overview: (id: string) => `/raptorjob/${id}?module=${DEFAULT_PARAMS.module}&submodule=dispatch`,
  tickets: (ticketId: string) => `/raptorjob/job-tickets/${ticketId}?module=${DEFAULT_PARAMS.module}&submodule=dispatch`,
  ticketOverviewDetails: (jobId: string, ticketId: string) =>
    `/raptorjob/${jobId}/job-tickets/${ticketId}/details?module=${DEFAULT_PARAMS.module}&submodule=dispatch`
};

export default RaptorJobRoutes;
